import { motion } from "framer-motion";

// Signature masked line-by-line reveal (kinetic hero moment).
export const maskLineParent = {
  hidden: {},
  show: { transition: { staggerChildren: 0.12, delayChildren: 0.15 } },
};

const maskLineChild = {
  hidden: { y: "110%" },
  show: { y: "0%", transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export const MaskLine = ({ children, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      variants={maskLineChild}
      className={`block pb-[0.14em] -mb-[0.14em] ${className}`}
    >
      {children}
    </motion.span>
  </span>
);
